import React from 'react';
import PageHeader from '../../components/PageHeader';

const NotificationsListHeader = () => <PageHeader title="Notifications" />;

export default NotificationsListHeader;
